const translations = [
        {
                selector: 'div#help-button p.help-button-contents',
                text: "Kontakt"
        },
        {
                selector: '.help-form .ak-field-group:nth-child(4) label',
                text: "Ihre E-Mail Adresse"
        },
        {
                selector: '.help-form > div > div:nth-child(3) p',
                text: "Dateigröße darf 5MB nicht überschreiten"
        },
        {
                selector: '.help-form label[for="attachment"]',
                text: "Datei wählen"
        },
        {
                selector: '.help-form .ak-field-group:nth-child(2) label',
                text: "Beschreibung"
        },
        {
                selector: '.help-form .ak-field-group:nth-child(1) label',
                text: "Betreff"
        },
        {
                selector: '.help-form .ak-field-group:nth-child(1) label',
                text: "Betreff"
        },
        {
                selector: '#submit-button',
                text: "Senden"
        },
]

let iframe;

const getIframe = setInterval(function () {
        iframe = document.getElementById('jsd-widget');

        if (iframe) {
                clearInterval(getIframe);
            const changeContactButton = setInterval(function() {
             var el = iframe.contentWindow.document.querySelector('#button-container .help-button-contents');
                var lang = 'de-DE';
                if(el && lang != 'de-DE') {
                    clearInterval(changeContactButton);
                    el.innerHTML = "Contact form";
                } 
            
            },100);
                iframe.contentWindow.onclick = function (e) {
                        if (e.target.className === "close-icon fit") {
                                clearAllIntervals()
                        } else {
                                waitIframeContent(e.target)
                        }
                }

                iframe.contentWindow.addEventListener("keydown", function (e) {
                        if (e.keyCode === 13) {
                                setTimeout(() => { waitIframeContent(e.target) }, 200);
                        }
                });
        }
}, 100);

function waitIframeContent(clickedElement) {
        let loadingSelector;
        const widgetOpeningStatus = iframe.contentWindow.document.querySelector('#search-container div.body.collapsed')

        
        if (widgetOpeningStatus) {
                loadingSelector = "#search-container input.search-field"

                const iframeCheckingInterval = setInterval(() => {
                        loadingElement = iframe.contentWindow.document.querySelectorAll(loadingSelector);

                        if (loadingElement) {
                                translations.forEach(el => changeContent(el));
                                clearAllIntervals()
                        }
                }, 100);
        } else {
                oneLoadingSelector = ".form-container"
                twoLoadingSelectors = "#search-container input.search-field, #search-container div.search-results"
                confirmLoadingSelector = "#confirmation-container"

                const iframeCheckingInterval = setInterval(() => {
                        if (clickedElement.type === 'submit') {
                                loadingElement = iframe.contentWindow.document.querySelector(confirmLoadingSelector);
                        } else {
                                loadingElement = iframe.contentWindow.document.querySelector(oneLoadingSelector);
                                loadingElements = iframe.contentWindow.document.querySelectorAll(twoLoadingSelectors);
                        }

                        if (loadingElement) {
                                translations.forEach(el => changeContent(el));
                                clearAllIntervals()
                        }
                        if (loadingElements.length >= 2) {
                                translations.forEach(el => changeContent(el));
                                clearAllIntervals()
                        }
                }, 100);
        }
}

function changeContent(translation) {
        const selector = iframe.contentWindow.document.querySelector(translation.selector);
        var lang = 'de-DE'; // Adjust this for multi lang
        if(lang == 'de-DE') {
            if (selector && translation.text) {
                    selector.innerHTML = translation.text;
            }
            if (selector && translation.placeholder) {
                    selector.placeholder = translation.placeholder
            }
        } else {
            iframe.contentWindow.document.querySelector('#widget-header .header-text').innerHTML = "Do you have questions?"
        }
        clearAllIntervals();

}

function clearAllIntervals() {
    const interval_id = window.setInterval(function(){}, Number.MAX_SAFE_INTEGER);
        for (i = 0; i < interval_id; i++) {
                window.clearInterval(i);
        }
}